import React from 'react';
import {TouchableOpacityProps} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {Btn, Icon, HeaderIconButtonsRow} from './styles';

interface Props extends Omit<TouchableOpacityProps, 'hitSlop'> {
  icon: string;
  active?: boolean;
  size?: number;
}

export function HeaderIconButton({icon, active, size, ...rest}: Props) {
  return (
    <Btn activeOpacity={0.75} active={active} {...(rest as any)}>
      <Icon name={icon} active={active} size={size ?? RFValue(18)} />
    </Btn>
  );
}

export {HeaderIconButtonsRow};
